import React, { useState } from "react";
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { createfeatureitem } from "../../../actions/ecommerce/ecommercefeatureitemAction";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Drawer,
  Button,
  Col,
  Row,
  Select,
  message,
  DatePicker,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateNew = ({
  createfeatureitem,
  reloadpage,
  feature,
  setreloadpage,
}) => {
  const initial = { remarks: "" };
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };

  const onFinish = (values) => {
    values["feature"] = feature.id;
    createfeatureitem(values).then((res) => {
      form.resetFields();
      setreloadpage(!reloadpage);
      setVisible(false);
    });

    // message.success(values.name + " Has been added to your contact list");
  };

  return (
    <>
      <>
        <Button
          type="primary"
          onClick={showDrawer}
          style={{ marginBottom: "10px", float: "right" }}
        >
          <PlusOutlined /> New item
        </Button>
        <Drawer
          title="Create a new item"
          width="30%"
          onClose={onClose}
          visible={visible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={initial}
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="title" label="Title">
                  <Input placeholder="Please enter title" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="sub_title" label="Sub title">
                  <Input placeholder="Please enter sub title" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="button_name" label="Button name">
                  <Input placeholder="Please enter button name" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="href" label="Button target">
                  <Input placeholder="Please enter button target" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="url" label="Image">
                  <Input placeholder="Please enter Image url" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="alt" label="Image alt">
                  <Input placeholder="image alt" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button onClick={onClose} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
      </>
    </>
  );
};

export default connect(null, { createfeatureitem })(CreateNew);
